import { Pizza } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PizzaSpinner({ label }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="pizza-spinner"
      className="flex flex-col items-center justify-center py-16 gap-3"
    >
      <Pizza className="w-12 h-12 text-[#FFDF00] pizza-spin" strokeWidth={2} />
      <p className="text-sm text-slate-500 font-medium">{label || t("common.loading")}</p>
    </div>
  );
}
